var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoldenLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 148.62 131.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#_1248-4);}.cls-2{fill:url(#_1248-3);}.cls-3{fill:url(#_1248-2);}.cls-4{fill:url(#_1321-3);}.cls-5{fill:url(#_1321-4);}.cls-6{fill:url(#_1321-2);}.cls-7{fill:url(#_1321-6);}.cls-8{fill:url(#_1321-5);}.cls-9{fill:url(#_236-12);}.cls-10{fill:url(#_236-11);}.cls-11{fill:url(#_236-16);}.cls-12{fill:url(#_236-10);}.cls-13{fill:url(#_236-15);}.cls-14{fill:url(#_236-14);}.cls-15{fill:url(#_236-13);}.cls-16{fill:url(#linear-gradient);}.cls-17{fill:url(#_127-2);}.cls-17,.cls-18,.cls-19{mix-blend-mode:color-dodge;}.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30{opacity:.5;}.cls-18{fill:url(#_127-3);}.cls-31{fill:url(#_236);}.cls-19{fill:url(#_127);}.cls-32{fill:url(#_1321);}.cls-33{fill:url(#_1248);}.cls-34{fill:url(#New_Gradient_Swatch_5);}.cls-20{fill:url(#New_Gradient_Swatch_1);}.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30{mix-blend-mode:multiply;}.cls-35{fill:url(#radial-gradient-2);}.cls-36{fill:url(#linear-gradient-8);}.cls-37{fill:url(#linear-gradient-9);}.cls-38{fill:url(#linear-gradient-3);}.cls-39{fill:url(#linear-gradient-4);}.cls-40{fill:url(#linear-gradient-2);}.cls-41{fill:url(#linear-gradient-6);}.cls-42{fill:url(#linear-gradient-7);}.cls-43{fill:url(#linear-gradient-5);}.cls-21{fill:url(#New_Gradient_Swatch_1-10);}.cls-22{fill:url(#New_Gradient_Swatch_1-11);}.cls-23{fill:url(#New_Gradient_Swatch_1-6);}.cls-24{fill:url(#New_Gradient_Swatch_1-9);}.cls-25{fill:url(#New_Gradient_Swatch_1-7);}.cls-26{fill:url(#New_Gradient_Swatch_1-4);}.cls-27{fill:url(#New_Gradient_Swatch_1-3);}.cls-28{fill:url(#New_Gradient_Swatch_1-8);}.cls-29{fill:url(#New_Gradient_Swatch_1-5);}.cls-30{fill:url(#New_Gradient_Swatch_1-2);}.cls-44{fill:url(#radial-gradient);}.cls-45{fill:url(#linear-gradient-40);}.cls-46{fill:url(#linear-gradient-14);}.cls-47{fill:url(#linear-gradient-18);}.cls-48{fill:url(#linear-gradient-22);}.cls-49{fill:url(#linear-gradient-20);}.cls-50{fill:url(#linear-gradient-21);}.cls-51{fill:url(#linear-gradient-23);}.cls-52{fill:url(#linear-gradient-15);}.cls-53{fill:url(#linear-gradient-19);}.cls-54{fill:url(#linear-gradient-16);}.cls-55{fill:url(#linear-gradient-17);}.cls-56{fill:url(#linear-gradient-13);}.cls-57{fill:url(#linear-gradient-12);}.cls-58{fill:url(#linear-gradient-10);}.cls-59{fill:url(#linear-gradient-11);}.cls-60{fill:url(#linear-gradient-27);}.cls-61{fill:url(#linear-gradient-24);}.cls-62{fill:url(#linear-gradient-26);}.cls-63{fill:url(#linear-gradient-38);}.cls-64{fill:url(#linear-gradient-35);}.cls-65{fill:url(#linear-gradient-37);}.cls-66{fill:url(#linear-gradient-34);}.cls-67{fill:url(#linear-gradient-39);}.cls-68{fill:url(#linear-gradient-36);}.cls-69{fill:url(#linear-gradient-25);}.cls-70{fill:url(#linear-gradient-28);}.cls-71{fill:url(#linear-gradient-29);}.cls-72{fill:url(#linear-gradient-33);}.cls-73{fill:url(#linear-gradient-30);}.cls-74{fill:url(#linear-gradient-32);}.cls-75{fill:url(#linear-gradient-31);}.cls-76{isolation:isolate;}.cls-77{fill:url(#_236-9);}.cls-78{fill:url(#_236-7);}.cls-79{fill:url(#_236-6);}.cls-80{fill:url(#_236-5);}.cls-81{fill:url(#_236-4);}.cls-82{fill:url(#_236-8);}.cls-83{fill:url(#_236-3);}.cls-84{fill:url(#_236-2);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_5",
    cx: 71.04,
    cy: 68.65,
    fx: -0.35,
    fy: 6.82,
    r: 110.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#f1eff1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#c7c2ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#a198a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#817587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#66576e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#503e59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#3e2c48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#331e3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#2c1736"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a1535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236",
    x1: 74.31,
    y1: 0,
    x2: 74.31,
    y2: 131.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d9e0ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#98aad2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7671a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1",
    x1: 74.31,
    y1: 83.91,
    x2: 74.31,
    y2: 131.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7d7cba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a5ba4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-2",
    x1: 74.31,
    y1: 129.92,
    x2: 74.31,
    y2: 1.93,
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_127",
    x1: 74.31,
    y1: -3960.5,
    x2: 74.31,
    y2: -3912.56,
    gradientTransform: "translate(0 -3912.56) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7d7cba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#acbcdd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-2",
    x1: 23.79,
    y1: 64.8,
    x2: 23.79,
    y2: 86.3,
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1321",
    x1: -6821.24,
    y1: 321.99,
    x2: -6821.24,
    y2: 302,
    gradientTransform: "translate(-2922.22 6184.97) rotate(118.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#85769c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#98aad2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d9e0ee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-3",
    x1: -6818.79,
    y1: 300.17,
    x2: -6818.79,
    y2: 317.89,
    gradientTransform: "translate(-2922.22 6184.97) rotate(118.16)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-4",
    x1: -6835,
    y1: 304.69,
    x2: -6835,
    y2: 311.03,
    gradientTransform: "translate(-2922.22 6184.97) rotate(118.16)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_127-2",
    x1: -6840.41,
    y1: 313.22,
    x2: -6840.41,
    y2: 307.96,
    gradientTransform: "translate(-2922.22 6184.97) rotate(118.16)",
    xlinkHref: "#_127"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1248",
    x1: -6836.1,
    y1: 293.3,
    x2: -6836.1,
    y2: 299.83,
    gradientTransform: "translate(-2922.22 6184.97) rotate(118.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6a5ba4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1f3b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-3",
    x1: -6805.56,
    y1: 307.96,
    x2: -6805.56,
    y2: 306.43,
    gradientTransform: "translate(-2922.22 6184.97) rotate(118.16)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-5",
    x1: 4.83,
    y1: 57.22,
    x2: 0.44,
    y2: 65.9,
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1321-2",
    x1: -11212.58,
    y1: 2672.31,
    x2: -11212.58,
    y2: 2652.32,
    gradientTransform: "translate(-2922.22 -11034.07) rotate(-118.16) scale(1 -1)",
    xlinkHref: "#_1321"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-6",
    x1: -11210.12,
    y1: 2650.48,
    x2: -11210.12,
    y2: 2668.21,
    gradientTransform: "translate(-2922.22 -11034.07) rotate(-118.16) scale(1 -1)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-7",
    x1: -11226.34,
    y1: 2654.85,
    x2: -11226.34,
    y2: 2661.39,
    gradientTransform: "translate(-2922.22 -11034.07) rotate(-118.16) scale(1 -1)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-8",
    x1: -11231.74,
    y1: 2663.53,
    x2: -11231.74,
    y2: 2658.27,
    gradientTransform: "translate(-2922.22 -11034.07) rotate(-118.16) scale(1 -1)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1248-2",
    x1: -11227.05,
    y1: 2644.08,
    x2: -11227.05,
    y2: 2650.49,
    gradientTransform: "translate(-2922.22 -11034.07) rotate(-118.16) scale(1 -1)",
    xlinkHref: "#_1248"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-4",
    x1: -11196.89,
    y1: 2658.28,
    x2: -11196.89,
    y2: 2656.74,
    gradientTransform: "translate(-2922.22 -11034.07) rotate(-118.16) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-9",
    x1: -0.18,
    y1: 81.87,
    x2: 5.98,
    y2: 77.39,
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1321-3",
    x1: 19.46,
    y1: 71.54,
    x2: 3.04,
    y2: 59.97,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#_1321"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-5",
    x1: 10.82,
    y1: 58.22,
    x2: 10.82,
    y2: 72.25,
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-6",
    x1: 10.82,
    y1: 21.03,
    x2: 10.82,
    y2: 35.06,
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-7",
    x1: -5815.93,
    y1: 64.8,
    x2: -5815.93,
    y2: 86.3,
    gradientTransform: "translate(-5691.1) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1321-4",
    x1: -4065.71,
    y1: 5470.44,
    x2: -4065.71,
    y2: 5450.45,
    gradientTransform: "translate(-2768.88 6184.97) rotate(61.84) scale(1 -1)",
    xlinkHref: "#_1321"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-10",
    x1: -4063.25,
    y1: 5448.62,
    x2: -4063.25,
    y2: 5466.34,
    gradientTransform: "translate(-2768.88 6184.97) rotate(61.84) scale(1 -1)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-11",
    x1: -4079.47,
    y1: 5453.14,
    x2: -4079.47,
    y2: 5459.48,
    gradientTransform: "translate(-2768.88 6184.97) rotate(61.84) scale(1 -1)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_127-3",
    x1: -4084.88,
    y1: 5461.67,
    x2: -4084.88,
    y2: 5456.41,
    gradientTransform: "translate(-2768.88 6184.97) rotate(61.84) scale(1 -1)",
    xlinkHref: "#_127"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1248-3",
    x1: 95.21,
    y1: 18.66,
    x2: 118.73,
    y2: 12.22,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#_1248"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-8",
    x1: -4050.02,
    y1: 5456.41,
    x2: -4050.02,
    y2: 5454.88,
    gradientTransform: "translate(-2768.88 6184.97) rotate(61.84) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-12",
    x1: -5834.89,
    y1: 57.22,
    x2: -5839.28,
    y2: 65.9,
    gradientTransform: "translate(-5691.1) rotate(-180) scale(1 -1)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1321-5",
    x1: -8457.04,
    y1: 7820.76,
    x2: -8457.04,
    y2: 7800.77,
    gradientTransform: "translate(-2768.88 -11034.07) rotate(-61.84)",
    xlinkHref: "#_1321"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-13",
    x1: -8454.59,
    y1: 7798.93,
    x2: -8454.59,
    y2: 7816.66,
    gradientTransform: "translate(-2768.88 -11034.07) rotate(-61.84)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-14",
    x1: -8470.81,
    y1: 7803.3,
    x2: -8470.81,
    y2: 7809.84,
    gradientTransform: "translate(-2768.88 -11034.07) rotate(-61.84)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-15",
    x1: -8476.21,
    y1: 7811.98,
    x2: -8476.21,
    y2: 7806.72,
    gradientTransform: "translate(-2768.88 -11034.07) rotate(-61.84)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1248-4",
    x1: -8471.51,
    y1: 7792.53,
    x2: -8471.51,
    y2: 7798.94,
    gradientTransform: "translate(-2768.88 -11034.07) rotate(-61.84)",
    xlinkHref: "#_1248"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-9",
    x1: -8441.36,
    y1: 7806.73,
    x2: -8441.36,
    y2: 7805.19,
    gradientTransform: "translate(-2768.88 -11034.07) rotate(-61.84)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-16",
    x1: -5839.9,
    y1: 81.87,
    x2: -5833.74,
    y2: 77.39,
    gradientTransform: "translate(-5691.1) rotate(-180) scale(1 -1)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1321-6",
    x1: -5820.26,
    y1: 71.54,
    x2: -5836.69,
    y2: 59.97,
    gradientTransform: "translate(-5691.1) rotate(-180) scale(1 -1)",
    xlinkHref: "#_1321"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-10",
    x1: -5828.9,
    y1: 58.22,
    x2: -5828.9,
    y2: 72.25,
    gradientTransform: "translate(-5691.1) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-11",
    x1: -5828.9,
    y1: 21.03,
    x2: -5828.9,
    y2: 35.06,
    gradientTransform: "translate(-5691.1) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 80.05,
    y1: 38.65,
    x2: 103.3,
    y2: 38.65,
    gradientTransform: "translate(-3.36 -2.03) rotate(-.33)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#fffefb",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fffdf1",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fffbe0",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#fff8c8",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#fff4a8",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#ffef82",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#ffea54",
    stopOpacity: 0.67
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#ffe421",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#fac400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#f6aa00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#f39700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#f18b00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f18800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 80.05,
    y1: 45.29,
    x2: 101.1,
    y2: 45.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 81.6,
    y1: 48.4,
    x2: 98.95,
    y2: 48.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 80.75,
    y1: 52.77,
    x2: 98.34,
    y2: 52.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 298.37,
    y1: 388.11,
    x2: 321.62,
    y2: 388.11,
    gradientTransform: "translate(-411.34 -94.35) rotate(-36.34)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 298.37,
    y1: 394.75,
    x2: 319.42,
    y2: 394.75,
    gradientTransform: "translate(-411.34 -94.35) rotate(-36.34)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 299.92,
    y1: 397.86,
    x2: 317.27,
    y2: 397.86,
    gradientTransform: "translate(-411.34 -94.35) rotate(-36.34)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 299.07,
    y1: 402.23,
    x2: 316.66,
    y2: 402.23,
    gradientTransform: "translate(-411.34 -94.35) rotate(-36.34)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -304.49,
    y1: -116.68,
    x2: -281.24,
    y2: -116.68,
    gradientTransform: "translate(271.39 316.19) rotate(36.12)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -304.49,
    y1: -110.04,
    x2: -283.45,
    y2: -110.04,
    gradientTransform: "translate(271.39 316.19) rotate(36.12)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -302.94,
    y1: -106.93,
    x2: -285.59,
    y2: -106.93,
    gradientTransform: "translate(271.39 316.19) rotate(36.12)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -303.79,
    y1: -102.56,
    x2: -286.21,
    y2: -102.56,
    gradientTransform: "translate(271.39 316.19) rotate(36.12)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -705.97,
    y1: -12.55,
    x2: -682.73,
    y2: -12.55,
    gradientTransform: "translate(304.62 735.25) rotate(72.55)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -705.97,
    y1: -5.91,
    x2: -684.93,
    y2: -5.91,
    gradientTransform: "translate(304.62 735.25) rotate(72.55)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -704.43,
    y1: -2.8,
    x2: -687.07,
    y2: -2.8,
    gradientTransform: "translate(304.62 735.25) rotate(72.55)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -705.28,
    y1: 1.57,
    x2: -687.69,
    y2: 1.57,
    gradientTransform: "translate(304.62 735.25) rotate(72.55)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -972.8,
    y1: 319.37,
    x2: -949.55,
    y2: 319.37,
    gradientTransform: "translate(79.31 1100.53) rotate(109.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -972.8,
    y1: 326.01,
    x2: -951.76,
    y2: 326.01,
    gradientTransform: "translate(79.31 1100.53) rotate(109.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -971.26,
    y1: 329.12,
    x2: -953.9,
    y2: 329.12,
    gradientTransform: "translate(79.31 1100.53) rotate(109.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -972.11,
    y1: 333.49,
    x2: -954.52,
    y2: 333.49,
    gradientTransform: "translate(79.31 1100.53) rotate(109.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -984.52,
    y1: 734.71,
    x2: -961.27,
    y2: 734.71,
    gradientTransform: "translate(-313.43 1250.55) rotate(146.02)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -984.52,
    y1: 741.35,
    x2: -963.48,
    y2: 741.35,
    gradientTransform: "translate(-313.43 1250.55) rotate(146.02)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -982.98,
    y1: 744.46,
    x2: -965.62,
    y2: 744.46,
    gradientTransform: "translate(-313.43 1250.55) rotate(146.02)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -983.83,
    y1: 748.83,
    x2: -966.24,
    y2: 748.83,
    gradientTransform: "translate(-313.43 1250.55) rotate(146.02)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -747.55,
    y1: 1076.29,
    x2: -724.3,
    y2: 1076.29,
    gradientTransform: "translate(-718.77 1139.14) rotate(-177.55)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -747.55,
    y1: 1082.93,
    x2: -726.5,
    y2: 1082.93,
    gradientTransform: "translate(-718.77 1139.14) rotate(-177.55)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -746,
    y1: 1086.04,
    x2: -728.65,
    y2: 1086.04,
    gradientTransform: "translate(-718.77 1139.14) rotate(-177.55)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -746.85,
    y1: 1090.41,
    x2: -729.26,
    y2: 1090.41,
    gradientTransform: "translate(-718.77 1139.14) rotate(-177.55)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -386.57,
    y1: 1213.14,
    x2: -363.33,
    y2: 1213.14,
    gradientTransform: "translate(-974.4 835.83) rotate(-143.54)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -386.57,
    y1: 1219.78,
    x2: -365.53,
    y2: 1219.78,
    gradientTransform: "translate(-974.4 835.83) rotate(-143.54)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: -385.03,
    y1: 1222.89,
    x2: -367.67,
    y2: 1222.89,
    gradientTransform: "translate(-974.4 835.83) rotate(-143.54)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: -385.88,
    y1: 1227.26,
    x2: -368.29,
    y2: 1227.26,
    gradientTransform: "translate(-974.4 835.83) rotate(-143.54)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 18.06,
    y1: 1105.25,
    x2: 41.31,
    y2: 1105.25,
    gradientTransform: "translate(-1003.81 416.44) rotate(-107.08)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 18.06,
    y1: 1111.89,
    x2: 39.11,
    y2: 1111.89,
    gradientTransform: "translate(-1003.81 416.44) rotate(-107.08)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 19.61,
    y1: 1115,
    x2: 36.97,
    y2: 1115,
    gradientTransform: "translate(-1003.81 416.44) rotate(-107.08)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 18.76,
    y1: 1119.37,
    x2: 36.35,
    y2: 1119.37,
    gradientTransform: "translate(-1003.81 416.44) rotate(-107.08)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 279.16,
    y1: 779.07,
    x2: 302.41,
    y2: 779.07,
    gradientTransform: "translate(-779.42 60.97) rotate(-70.65)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 279.16,
    y1: 785.71,
    x2: 300.21,
    y2: 785.71,
    gradientTransform: "translate(-779.42 60.97) rotate(-70.65)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 280.71,
    y1: 788.82,
    x2: 298.07,
    y2: 788.82,
    gradientTransform: "translate(-779.42 60.97) rotate(-70.65)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 279.86,
    y1: 793.19,
    x2: 297.45,
    y2: 793.19,
    gradientTransform: "translate(-779.42 60.97) rotate(-70.65)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 14.57,
    cy: -31.99,
    fx: 14.57,
    fy: -31.99,
    r: 7.68,
    gradientTransform: "translate(55.85 92.69) rotate(9.36)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efe300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#efd600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#efb600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f18800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: -82.96,
    cy: 974.92,
    fx: -82.96,
    fy: 974.92,
    r: 11.19,
    gradientTransform: "translate(-697.9 -532.66) rotate(-57.05)",
    xlinkHref: "#radial-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-76"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-34",
    cx: 74.99,
    cy: 66.36,
    r: 63.55
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m74.32,0C37.9,0,8.39,29.52,8.39,65.93s29.52,65.93,65.93,65.93,65.93-29.52,65.93-65.93S110.73,0,74.32,0Zm0,128.16c-16.62,0-32.25-6.47-44-18.23-11.76-11.76-18.23-27.38-18.23-44.01s6.47-32.25,18.23-44C42.06,10.17,57.69,3.69,74.32,3.69s32.25,6.47,44,18.23c11.76,11.76,18.23,27.38,18.23,44s-6.47,32.25-18.23,44.01c-11.75,11.75-27.38,18.23-44,18.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m74.32,130.05c-29.77,0-54.97-19.4-63.44-46.14,7.83,27.67,33.27,47.94,63.44,47.94s55.61-20.27,63.44-47.94c-8.48,26.74-33.67,46.14-63.44,46.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "m119.57,20.67C107.48,8.58,91.41,1.93,74.32,1.93s-33.16,6.66-45.25,18.75c-12.09,12.09-18.74,28.16-18.74,45.25s6.66,33.16,18.74,45.25c12.09,12.09,28.16,18.74,45.25,18.74s33.17-6.66,45.25-18.74c12.09-12.09,18.74-28.16,18.74-45.25s-6.66-33.17-18.74-45.25Zm-1.25,89.26c-11.75,11.75-27.38,18.23-44,18.23s-32.25-6.47-44-18.23c-11.76-11.76-18.23-27.38-18.23-44.01s6.47-32.25,18.23-44C42.06,10.17,57.69,3.69,74.32,3.69s32.25,6.47,44,18.23c11.76,11.76,18.23,27.38,18.23,44s-6.47,32.25-18.23,44.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m137.76,47.94C129.93,20.27,104.49,0,74.32,0S18.7,20.27,10.87,47.94C19.35,21.2,44.55,1.99,74.32,1.99s54.97,19.21,63.44,45.95Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m21.11,98.93l1.72,5.03s.43,1.37-.28,2.8l3.93,4.53-.52-6.18-4.85-6.18Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m26.96,18.03c-2.91,9.79-7.21,17.51-7.21,17.51-.98,2.17-2.33,5.08-2.33,5.08-.57,1.24-1.56,3.84-1.56,3.84,2.82-3.12,4.66-5.85,6.82-8.67,4.17-5.45,7.01-15.06,8.4-20.66.65-2.63.99-4.37.99-4.37,2.42-1.17,3.7-1.9,3.85-1.98.22-.11.45-.21.67-.31-.99-1.3-2.2-2.27-2.2-2.27-3.74-.56-5.28,1.48-5.28,1.48-.23,1.88-.54,3.7-.91,5.44-.37,1.72-.79,3.36-1.26,4.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "m17.43,40.62s2.11-4.66,2.25-4.9c0,0,4.38-7.9,7.29-17.69.46-1.56.89-3.2,1.26-4.91,0,0,.75,13.06-10.79,27.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "m31.39,15.89s-.45.46-1.8,4.68c0,0,.46-5.89,1.99-10.6,0,0,1.6-2.99,2.85-3.75.19.16,1.72,1.19,3.97,4.41-.22.1-.91.64-1.13.75-.15.09-2.43,1.73-5.88,4.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m29.13,7.68s1.33-1.77,4.52-1.57c-1.36,1.86-3.95,2.3-4.52,1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m31.39,15.89l.97-2.77c1.29-1.73,2.77-2.63,2.77-2.63,0,0,1.31.19,2.57.62l-.42.28c-3.05,2.01-5.88,4.51-5.88,4.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m18.15,41.78s.83-2.07,1.43-3.99l.85-3.5c-.12.15-.52,1.06-.67,1.24-1.61,3.22-2.54,5.26-3.89,8.92,0,0,1.64-1.96,2.28-2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "m10.32,50.03s-4.56,4.81-7.29,15.9H0s.72-12.21,12.37-22.62l-2.05,6.73Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m26.96,113.82c-2.91-9.79-7.21-17.51-7.21-17.51-.98-2.17-2.33-5.08-2.33-5.08-.57-1.24-1.56-3.84-1.56-3.84,2.82,3.12,4.66,5.85,6.82,8.67,4.17,5.45,7.01,15.06,8.4,20.66.65,2.63.99,4.37.99,4.37,2.42,1.17,3.7,1.9,3.85,1.98.22.11.45.21.67.31-.99,1.3-2.2,2.27-2.2,2.27-3.74.56-5.28-1.48-5.28-1.48-.23-1.88-.54-3.7-.91-5.44-.37-1.72-.79-3.36-1.26-4.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "m17.43,91.24s2.11,4.66,2.25,4.9c0,0,4.38,7.9,7.29,17.69.46,1.56.89,3.2,1.26,4.91,0,0,.75-13.06-10.79-27.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m31.05,115.61s-.11-.11-1.46-4.33c0,0,.46,5.89,1.99,10.6,0,0,1.6,2.99,2.85,3.75.19-.16,3.4-3.02,4.3-4.2-.22-.1-1.69-1.17-1.91-1.28-.15-.09-2.9-1.86-5.77-4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m29.13,124.17s1.33,1.77,4.52,1.57c-1.36-1.86-3.95-2.3-4.52-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m31.05,115.61l.82,2.29c.61,2.08,2.11,3.67,2.11,3.67,0,0,1.06.22,2.01-.28l1.2-.89c-.61-.33-4.12-3.04-6.15-4.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m18.15,90.07s.83,2.07,1.43,3.99l.85,3.5c-.12-.15-.52-1.06-.67-1.24-1.61-3.22-2.54-5.26-3.89-8.92,0,0,1.64,1.96,2.28,2.67Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m10.32,81.82s-4.56-4.81-7.29-15.9H0s.72,12.21,12.37,22.62l-2.05-6.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m3.03,65.93c2.59-10.81,7.29-15.9,7.29-15.9l1.17-3.85C2.86,54.36,1.46,65.93,1.46,65.93c0,0,1.4,11.57,10.03,19.74l-1.17-3.85s-4.7-5.09-7.29-15.9Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m9.27,80.49s.36,2.19.3,3.18l.74,2.91,2.05,1.97-.88-2.88-1.17-3.85-1.05-1.33Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "12.37 43.3 11.49 46.18 10.32 50.03 9.27 51.36 9.27 48.53 11.49 44.11 12.37 43.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m127.52,98.93l-1.72,5.03s-.43,1.37.28,2.8l-3.93,4.53.52-6.18,4.85-6.18Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m121.66,18.03c2.91,9.79,7.21,17.51,7.21,17.51.98,2.17,2.33,5.08,2.33,5.08.57,1.24,1.56,3.84,1.56,3.84-2.82-3.12-4.66-5.85-6.82-8.67-4.17-5.45-7.01-15.06-8.4-20.66-.65-2.63-.99-4.37-.99-4.37-2.42-1.17-3.7-1.9-3.85-1.98-.22-.11-.45-.21-.67-.31.99-1.3,2.2-2.27,2.2-2.27,3.74-.56,5.28,1.48,5.28,1.48.23,1.88.54,3.7.91,5.44.37,1.72.79,3.36,1.26,4.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m131.2,40.62s-2.11-4.66-2.25-4.9c0,0-4.38-7.9-7.29-17.69-.46-1.56-.89-3.2-1.26-4.91,0,0-.75,13.06,10.79,27.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m117.24,15.89s.45.46,1.8,4.68c0,0-.46-5.89-1.99-10.6,0,0-1.6-2.99-2.85-3.75-.19.16-1.72,1.19-3.97,4.41.22.1.91.64,1.13.75.15.09,2.43,1.73,5.88,4.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m119.5,7.68s-1.33-1.77-4.52-1.57c1.36,1.86,3.95,2.3,4.52,1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m117.24,15.89l-.97-2.77c-1.29-1.73-2.77-2.63-2.77-2.63,0,0-1.31.19-2.57.62l.42.28c3.05,2.01,5.88,4.51,5.88,4.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m130.48,41.78s-.83-2.07-1.43-3.99l-.85-3.5c.12.15.52,1.06.67,1.24,1.61,3.22,2.54,5.26,3.89,8.92,0,0-1.64-1.96-2.28-2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m138.31,50.03s4.56,4.81,7.29,15.9h3.03s-.72-12.21-12.37-22.62l2.05,6.73Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m121.66,113.82c2.91-9.79,7.21-17.51,7.21-17.51.98-2.17,2.33-5.08,2.33-5.08.57-1.24,1.56-3.84,1.56-3.84-2.82,3.12-4.66,5.85-6.82,8.67-4.17,5.45-7.01,15.06-8.4,20.66-.65,2.63-.99,4.37-.99,4.37-2.42,1.17-3.7,1.9-3.85,1.98-.22.11-.45.21-.67.31.99,1.3,2.2,2.27,2.2,2.27,3.74.56,5.28-1.48,5.28-1.48.23-1.88.54-3.7.91-5.44.37-1.72.79-3.36,1.26-4.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m131.2,91.24s-2.11,4.66-2.25,4.9c0,0-4.38,7.9-7.29,17.69-.46,1.56-.89,3.2-1.26,4.91,0,0-.75-13.06,10.79-27.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m117.58,115.61s.11-.11,1.46-4.33c0,0-.46,5.89-1.99,10.6,0,0-1.6,2.99-2.85,3.75-.19-.16-3.4-3.02-4.3-4.2.22-.1,1.69-1.17,1.91-1.28.15-.09,2.9-1.86,5.77-4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m119.5,124.17s-1.33,1.77-4.52,1.57c1.36-1.86,3.95-2.3,4.52-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m117.58,115.61l-.82,2.29c-.61,2.08-2.11,3.67-2.11,3.67,0,0-1.06.22-2.01-.28l-1.2-.89c.61-.33,4.12-3.04,6.15-4.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m130.48,90.07s-.83,2.07-1.43,3.99l-.85,3.5c.12-.15.52-1.06.67-1.24,1.61-3.22,2.54-5.26,3.89-8.92,0,0-1.64,1.96-2.28,2.67Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m138.31,81.82s4.56-4.81,7.29-15.9h3.03s-.72,12.21-12.37,22.62l2.05-6.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m145.6,65.93c-2.59-10.81-7.29-15.9-7.29-15.9l-1.17-3.85c8.63,8.18,10.03,19.74,10.03,19.74,0,0-1.4,11.57-10.03,19.74l1.17-3.85s4.7-5.09,7.29-15.9Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m139.35,80.49s-.36,2.19-.3,3.18l-.74,2.91-2.05,1.97.88-2.88,1.17-3.85,1.04-1.33Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "136.25 43.3 137.13 46.18 138.31 50.03 139.35 51.36 139.35 48.53 137.13 44.11 136.25 43.3"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m100.05,16.06s-2.31,8.58-7.18,14.24c-5.21,6.06-9.3,11.42-9.3,11.42,0,0-6.47,8.4-6.54,14.4,0,0,1.62-7.39,6.14-11.82,5.94-5.83,16.15-17.03,16.88-28.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m97.9,26.4s-2.89,7.86-9.15,13.6c-4.57,4.18-7.06,7.91-7.06,7.91,0,0-4.59,6.73-4.64,11.16,0,0,1.72-5.8,4.78-9.33.58-.67,3.01-3.55,6.2-6.38,4.47-3.97,9.24-11.8,9.87-16.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m95.81,35.43s-1.79,4.35-6.81,8.37-9.71,9.09-10.42,12.46c0,0,.49-2.08,6.5-6.78,6.01-4.7,10.22-11.29,10.74-14.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m95.23,40.51s-1.06,5.13-7.89,8.76c-7.46,3.97-9.59,10.66-9.59,10.66,0,0,1.28-4.22,8.14-7.76,1-.52,2.42-1.35,3.21-2.15,2.27-2.33,5.65-6.89,6.13-9.5Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m65.87,11.65s3.18,8.3,2.57,15.74c-.65,7.97-.81,14.7-.81,14.7,0,0-.3,10.6,3.17,15.49,0,0-3.03-6.93-1.98-13.17,1.38-8.21,3.06-23.27-2.94-32.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m70.22,21.28s2.28,8.06.59,16.38c-1.24,6.07-1.06,10.55-1.06,10.55,0,0,.24,8.14,2.8,11.75,0,0-2.02-5.7-1.62-10.36.08-.88.35-4.64,1.27-8.81,1.29-5.84.54-14.98-1.98-19.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m73.84,29.82s1.11,4.57-.59,10.77c-1.7,6.2-2.51,13.06-1.11,16.21,0,0-.83-1.97,1.27-9.3,2.1-7.33,1.64-15.14.43-17.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m76.35,34.27s2.16,4.78-1.23,11.72c-3.71,7.6-1.49,14.26-1.49,14.26,0,0-1.45-4.16,2.02-11.06.51-1.01,1.16-2.51,1.33-3.63.47-3.22.52-8.9-.63-11.29Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m124.76,40.03s-6.96,5.53-14.24,7.19c-7.79,1.78-14.26,3.66-14.26,3.66,0,0-10.2,2.91-13.82,7.69,0,0,5.69-4.98,11.96-5.86,8.24-1.16,23.11-4.1,30.35-12.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "m116.89,47.07s-7,4.61-15.44,5.5c-6.16.65-10.38,2.17-10.38,2.17,0,0-7.69,2.68-10.36,6.21,0,0,4.83-3.64,9.39-4.66.87-.19,4.53-1.07,8.78-1.45,5.95-.53,14.44-4,18.01-7.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "m109.84,53.09s-4.03,2.43-10.45,2.68c-6.42.25-13.21,1.54-15.79,3.83,0,0,1.63-1.39,9.26-1.59s14.93-3,16.98-4.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "m106.35,56.83s-3.91,3.5-11.55,2.36c-8.36-1.24-14.05,2.88-14.05,2.88,0,0,3.53-2.64,11.16-1.41,1.11.18,2.74.35,3.86.17,3.21-.52,8.64-2.19,10.58-4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "m130.89,74.19s-8.88.32-15.72-2.67c-7.33-3.2-13.65-5.52-13.65-5.52,0,0-9.93-3.71-15.69-2.02,0,0,7.54-.62,13.1,2.39,7.32,3.96,21.03,10.43,31.96,7.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m120.38,75.19s-8.37-.45-15.69-4.75c-5.34-3.14-9.64-4.42-9.64-4.42,0,0-7.78-2.41-12.03-1.15,0,0,6.05-.06,10.33,1.82.81.36,4.28,1.83,7.92,4.05,5.11,3.11,14,5.36,19.11,4.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m111.13,75.85s-4.68-.43-10-4.05c-5.32-3.61-11.54-6.6-14.98-6.29,0,0,2.13-.15,8.39,4.21,6.26,4.36,13.8,6.45,16.58,6.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m106.11,76.78s-5.22.49-10.69-4.96c-5.99-5.97-13.01-6.03-13.01-6.03,0,0,4.41-.02,9.81,5.5.79.81,2,1.91,3,2.43,2.89,1.48,8.25,3.37,10.89,3.06Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m115.22,105.54s-7.28-5.1-10.95-11.6c-3.93-6.96-7.57-12.63-7.57-12.63,0,0-5.7-8.95-11.31-11.05,0,0,6.39,4.04,9.02,9.79,3.46,7.57,10.52,20.99,20.81,25.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m106.23,100.01s-6.41-5.4-9.67-13.24c-2.38-5.72-5.04-9.33-5.04-9.33,0,0-4.76-6.61-8.91-8.16,0,0,4.87,3.59,7.15,7.67.43.77,2.31,4.04,3.89,8,2.21,5.56,7.95,12.7,12.58,15.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m98.45,94.96s-3.48-3.17-5.55-9.25c-2.07-6.09-5.24-12.22-8.17-14.04,0,0,1.79,1.17,4.16,8.42,2.37,7.25,7.13,13.46,9.55,14.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "m93.87,92.69s-4.47-2.75-5.55-10.4c-1.19-8.37-6.76-12.64-6.76-12.64,0,0,3.53,2.64,4.53,10.3.15,1.12.44,2.73.93,3.75,1.42,2.93,4.56,7.66,6.85,9Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m84.27,120.62s-2.83-8.43-1.92-15.83c.98-7.93,1.41-14.65,1.41-14.65,0,0,.73-10.58-2.53-15.61,0,0,2.74,7.05,1.44,13.24-1.71,8.15-4.01,23.13,1.59,32.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m80.33,110.82s-1.95-8.15.09-16.39c1.49-6.01,1.49-10.5,1.49-10.5,0,0,.1-8.14-2.32-11.86,0,0,1.78,5.78,1.19,10.42-.11.88-.54,4.62-1.63,8.75-1.53,5.78-1.15,14.94,1.18,19.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m77.06,102.14s-.92-4.61,1.04-10.74c1.95-6.12,3.05-12.94,1.77-16.15,0,0,.75,2-1.65,9.24-2.4,7.24-2.26,15.06-1.16,17.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m74.74,97.59s-1.96-4.86,1.71-11.66c4.02-7.44,2.08-14.19,2.08-14.19,0,0,1.28,4.22-2.48,10.97-.55.99-1.27,2.46-1.48,3.57-.6,3.2-.88,8.87.16,11.31Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m50.06,114.76s2.73-8.46,7.86-13.88c5.5-5.8,9.84-10.95,9.84-10.95,0,0,6.87-8.08,7.24-14.06,0,0-1.98,7.3-6.7,11.51-6.22,5.54-16.96,16.23-18.23,27.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "m52.7,104.53s3.27-7.71,9.8-13.14c4.77-3.96,7.44-7.56,7.44-7.56,0,0,4.91-6.49,5.18-10.92,0,0-2,5.71-5.23,9.09-.61.64-3.18,3.4-6.51,6.07-4.66,3.74-9.8,11.34-10.68,16.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m55.23,95.61s2-4.26,7.21-8.02,10.14-8.6,11.02-11.94c0,0-.59,2.06-6.82,6.46-6.23,4.4-10.76,10.78-11.41,13.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m56.06,90.57s1.31-5.08,8.3-8.37c7.65-3.6,10.1-10.18,10.1-10.18,0,0-1.48,4.15-8.51,7.36-1.03.47-2.48,1.23-3.31,2-2.38,2.22-5.98,6.61-6.58,9.2Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m26.89,92.13s6.99-5.49,14.28-7.11c7.8-1.73,14.28-3.57,14.28-3.57,0,0,10.22-2.85,13.86-7.61,0,0-5.72,4.94-11.99,5.79-8.25,1.11-23.14,3.96-30.43,12.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m34.8,85.13s7.03-4.57,15.47-5.4c6.16-.61,10.39-2.11,10.39-2.11,0,0,7.7-2.64,10.4-6.15,0,0-4.85,3.61-9.42,4.61-.87.19-4.53,1.04-8.79,1.39-5.96.5-14.47,3.92-18.06,7.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "m41.89,79.15s4.04-2.41,10.46-2.62,13.22-1.46,15.81-3.74c0,0-1.64,1.38-9.26,1.54-7.63.16-14.95,2.91-17.01,4.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "m45.39,75.44s3.93-3.47,11.56-2.29c8.35,1.29,14.06-2.79,14.06-2.79,0,0-3.55,2.62-11.17,1.34-1.11-.19-2.74-.37-3.86-.2-3.21.51-8.65,2.14-10.6,3.94Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m21.46,58.13s8.89-.26,15.71,2.77c7.31,3.24,13.61,5.61,13.61,5.61,0,0,9.91,3.78,15.67,2.12,0,0-7.54.57-13.09-2.47-7.3-4.01-20.96-10.56-31.91-8.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m31.97,57.2s8.36.5,15.66,4.85c5.32,3.17,9.61,4.48,9.61,4.48,0,0,7.76,2.46,12.02,1.23,0,0-6.05.02-10.31-1.89-.81-.36-4.26-1.86-7.9-4.1-5.09-3.14-13.96-5.45-19.08-4.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "m41.23,56.6s4.68.46,9.97,4.11,11.5,6.68,14.94,6.39c0,0-2.14.14-8.37-4.27s-13.75-6.54-16.54-6.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "m46.26,55.7s5.22-.46,10.66,5.03c5.95,6,12.97,6.11,12.97,6.11,0,0-4.41,0-9.78-5.56-.79-.81-1.98-1.93-2.99-2.45-2.89-1.5-8.23-3.42-10.87-3.13Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m37.01,27.1s7.3,5.07,11,11.55c3.95,6.95,7.62,12.6,7.62,12.6,0,0,5.73,8.92,11.35,11.01,0,0-6.41-4.02-9.06-9.76-3.49-7.56-10.6-20.95-20.91-25.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "m46.02,32.6s6.43,5.37,9.72,13.2c2.4,5.71,5.08,9.31,5.08,9.31,0,0,4.79,6.59,8.94,8.13,0,0-4.88-3.57-7.18-7.65-.44-.77-2.33-4.03-3.92-7.99-2.23-5.55-8-12.67-12.64-15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m53.82,37.61s3.49,3.15,5.58,9.23c2.09,6.08,5.29,12.2,8.22,14.01,0,0-1.8-1.16-4.2-8.4-2.4-7.24-7.19-13.43-9.61-14.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "m58.41,39.87s4.48,2.73,5.59,10.38c1.22,8.36,6.81,12.62,6.81,12.62,0,0-3.54-2.62-4.57-10.28-.15-1.12-.45-2.73-.95-3.74-1.43-2.92-4.59-7.64-6.88-8.97Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-44",
    cx: 75.42,
    cy: 63.49,
    r: 7.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m82.81,68.44c-2.68,4.13-8.19,5.3-12.32,2.63-4.13-2.68-5.3-8.19-2.63-12.32.1-.16.21-.3.32-.45-.96.75-1.82,1.66-2.52,2.74-3.38,5.22-1.89,12.19,3.32,15.57,5.22,3.38,12.19,1.89,15.57-3.32,2.94-4.53,2.2-10.37-1.46-14.05,1.56,2.79,1.57,6.33-.29,9.2Z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldenLight);
export default __webpack_public_path__ + "static/media/golden-light.bf62c0cca7c88261111a46415fb352ee.svg";
export { ForwardRef as ReactComponent };